import { ExerciseFormatter } from "@domain/exercise/exercise-formatter";
import { useI18n } from "@core/i18n/i18n";
import { useMemo } from "react";

export const useExerciseFormatter = (): ExerciseFormatter => {
  const { format } = useI18n();
  return useMemo(() => new ExerciseFormatter(format), [format]);
};